// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1d2734f48e2918cf814f","655":"20c2f4c2a5f610014108"}[chunkId] + ".js";
};